module.exports = __webpack_public_path__ + "static/service04-2056cb72d2cf51803c1620580bfce4c9.jpg";